// src/pages/SolutionDetailsPage.tsx

import React from "react";
import { useParams, Link } from "react-router-dom";
import { appData } from "../data/appData";
import PageConfigurator from "../components/PageConfigurator";
import "../styles/SolutionDetailsPage.css";
import { SolutionDetailsPageData } from "../types/interfaces"; // Ensure this import is correct

const SolutionDetailsPage: React.FC = () => {
  const { solutionId } = useParams<{ solutionId: string }>();

  // Explicitly type solutionPageData
  const solutionPageData: SolutionDetailsPageData | undefined = appData.pages.solutionDetails.find(
    (page) => page.id === solutionId
  );

  if (!solutionPageData) {
    return (
      <div className="solution-not-found">
        <h2>Solution Not Found</h2>
        <p>The solution you're looking for does not exist.</p>
        <Link to="/" className="back-button">
          &larr; Back to Home
        </Link>
      </div>
    );
  }

  // Use type guard for pageType
  if (!solutionPageData.pageType) {
    return (
      <div className="invalid-data">
        <h2>Invalid Data</h2>
        <p>The solution data is incomplete.</p>
        <Link to="/" className="back-button">
          &larr; Back to Home
        </Link>
      </div>
    );
  }

  const pageType = solutionPageData.pageType;

  return (
    <div className="solution-details-page">
      <Link to={`/${pageType}`} className="back-button">
        &larr; Back to {pageType.charAt(0).toUpperCase() + pageType.slice(1)}
      </Link>
      <PageConfigurator
        pageData={solutionPageData}
        pageName="solution-details"
      />
    </div>
  );
};

export default SolutionDetailsPage;
